import StatementState, { actions } from '@/pages/Statements/Statements.redux.js';
import { ProfileOutlined, FileTextOutlined, WalletOutlined } from '@ant-design/icons';
import React, { lazy } from 'react';

import { registerNavigation } from '@/core/navigation';
import { registerReduxStore } from '@/core/store';
import { registerRoutes } from '@/core/routes';

const Statements = lazy(() => import('./Statements'));


registerReduxStore('statements', StatementState, actions);


registerRoutes([
    {
        path:        '/statements',
        exact:       true,
        render:      <Statements />,
        title:       'Statements',
        private:     true,
        permissions: [],
    },
]);



registerNavigation({
    title:       'Statements',
    permissions: [],
    single:      false,
    top:         true,
    home:        true,
    icon:        <FileTextOutlined />,
    children:    [
        {
            title:       'Statements',
            url:         '/statements',
            icon:        <FileTextOutlined />,
            permissions: [],
        },
    ],
});


console.log('Registered Statements Plugin');
